import React, { useState, useContext } from 'react'
import ListGroup from 'react-bootstrap/ListGroup'
import { FirebaseContext } from '../firebase'
import formatDistanceToNow from 'date-fns/formatDistanceToNow'
import firebase from 'firebase'
import { RIEInput } from 'riek'
import _ from 'lodash'

function ArticleListItem(props) {
    const [onConfirm, setOnConfirm] = useState(false)
    const { fire } = useContext(FirebaseContext)

    function handleClick(e) {
        e.preventDefault()
        if (!onConfirm) {
            setOnConfirm(true)
        } else {
            deleteArticle()
        }
    }

    function deleteArticle() {
        fire.firestore().collection('articles').doc(props.article.id).delete()
            .then(
                fire.firestore().collection('sequences').doc(props.sequenceId)
                    .update({
                        'articles': firebase.firestore.FieldValue.arrayRemove(props.article.id)
                    })
            )
            .catch(err => console.log(err))
    }

    function handleRename(p) {
        fire.firestore().collection('articles').doc(props.article.id)
            .update({
                title: p.title
            })
    }

    return (
        <ListGroup.Item className="mb-1" action key={props.article.id} style={{cursor: "move"}}>
            <div className="d-flex w-100 justify-content-between">
                <h5 className="mb-1">
                    <RIEInput 
                        change={handleRename}
                        propName='title'
                        validate={_.isString}
                        editProps={{
                            maxLength: 80
                        }}
                        value={props.article.title} />
                </h5>
                {props.article.created &&
                    <small className="text-muted text-nowrap d-none d-md-block">
                        Added {formatDistanceToNow(props.article.created)} ago
                    </small>}
            </div>
            <p className="text-break mb-0"><small>{props.article.url}</small></p>
            <p className="mb-0">
                <small><a onClick={handleClick} href="/#" className="text-danger">{onConfirm ? "Really delete?" : "Delete"}</a></small>
            </p>
        </ListGroup.Item>
    )
}

export default ArticleListItem